import { useEffect, useState, Suspense } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getTinyAccountById } from 'store/account';

import { ActivationNavigation } from './ActivationNavigation';
import { Kit } from '@repo/types';
import TinyAccount from 'types/TinyAccount';
import useTinyAccounts from 'services/account/useTinyAccounts';
import { Spinfinity } from 'components';

export type KitActivationState = {
  kit: Partial<Kit>;
  tinyAccount: { id: string } & Partial<TinyAccount>;
};

export type KitStepProps = {
  tinyAccounts: TinyAccount[];
  step: number;
  setCurrentActivationStep: (step: number) => void;
  activationState: KitActivationState;
  setActivationState: (state: KitActivationState) => void;
};

export type KitStep = {
  id: string;
  Component: React.FC<KitStepProps>;
  exactPath?: boolean;
  optional?: boolean;
};

interface ActivateKitProps {
  readonly steps: readonly KitStep[];
}

export const ActivateKit: React.FC<ActivateKitProps> = ({ steps }) => {
  const { tinyAccounts } = useTinyAccounts();
  const [searchParams, setSearchParams] = useSearchParams();
  const tinyaccount_id = searchParams.get('tinyaccount_id');
  const tinyAccount = useSelector(getTinyAccountById(tinyaccount_id ?? ''));

  const [currentActivationStep, setCurrentActivationStep] = useState(
    tinyaccount_id ? 1 : 0,
  );

  const [activationState, setActivationState] = useState<KitActivationState>({
    tinyAccount: tinyAccount ? tinyAccount : { id: '' },
    kit: {},
  });
  useEffect(() => {
    if (tinyAccount && !activationState.tinyAccount.id) {
      setActivationState({
        ...activationState,
        tinyAccount,
      });
      if (currentActivationStep === 0) setCurrentActivationStep(1);
    }
  }, [tinyAccount, activationState, currentActivationStep]);

  const StepComponent = steps[currentActivationStep]?.Component;

  return (
    <div className='max-w-100 p-3'>
      <ActivationNavigation
        step={currentActivationStep}
        startingStep={tinyAccount ? 1 : 0}
        steps={steps}
        setCurrentActivationStep={setCurrentActivationStep}
        kitId={activationState.kit.id}
      />
      {tinyAccounts && StepComponent && (
        <Suspense fallback={<Spinfinity />}>
          <StepComponent
            key={steps[currentActivationStep]?.id}
            tinyAccounts={tinyAccounts}
            step={currentActivationStep}
            setCurrentActivationStep={setCurrentActivationStep}
            activationState={activationState}
            setActivationState={setActivationState}
          />
        </Suspense>
      )}
    </div>
  );
};
